// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"fb665af9","320":"2ba7343d","787":"8b21d8dd"}[chunkId] + ".chunk.js";
};